import { gsap } from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'

gsap.registerPlugin(ScrollTrigger)

export default class PictoList {
  constructor(el) {
    this.el = el
    this.icons = el.querySelectorAll('.picto-list--icon')
    if (this.icons.length) this.init()
  }

  init() {
    gsap.fromTo(this.icons,
      { y: -40, opacity: 0 },
      {
        y: 0,
        opacity: 1,
        duration: 0.6,
        ease: 'bounce.out',
        stagger: 0.12,
        scrollTrigger: {
          trigger: this.el,
          start: 'top 80%',
          toggleActions: 'play none none none',
        }
      }
    )
  }
}
